import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  preview(event) {
    const file = event.target.files[0]
    const previewContainer = document.getElementById('image-preview')
    const previewImage = document.getElementById('preview-image')
    
    if (file && file.type.match('image.*')) {
      const reader = new FileReader()
      
      reader.onload = (e) => {
        previewImage.src = e.target.result
        previewContainer.classList.remove('d-none')
      }
      
      reader.readAsDataURL(file)
    } else {
      previewContainer.classList.add('d-none')
    }
  }
}
